import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Gift, Check } from "lucide-react";

export default function RedeemGift() {
  const { user, refresh } = useAuth() || {};
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!user) { toast.error("Sign in first"); nav("/login"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/gifts/redeem", { code });
      setResult(data); toast.success(`Premium extended by ${data.months} months!`);
      refresh?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Invalid code"); }
    finally { setLoading(false); }
  };

  return (
    <div className="pt-16" data-testid="redeem-gift-page">
      <div className="max-w-lg mx-auto px-6 py-14">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2 flex items-center gap-2"><Gift className="w-3 h-3"/>Redeem a Gift</p>
        <h1 className="font-heading text-4xl font-bold mb-6">Enter Your Code</h1>

        {result ? (
          <div className="bg-[#0A0A0E] border border-[#D4AF37]/40 rounded-2xl p-8 text-center" data-testid="redeem-success">
            <div className="w-16 h-16 rounded-full bg-[#D4AF37]/20 border-2 border-[#D4AF37] flex items-center justify-center mx-auto mb-4"><Check className="w-8 h-8 text-[#D4AF37]"/></div>
            <h3 className="font-heading text-2xl font-bold mb-2">You're Premium!</h3>
            <p className="text-white/70 mb-4">{result.months} months of ad-free viewing added to your account.</p>
            <p className="text-xs text-white/40 mb-6">Premium active until {new Date(result.current_period_end).toLocaleDateString([], {year:'numeric',month:'long',day:'numeric'})}</p>
            <button onClick={()=>nav("/")} className="btn-gold px-6 py-2 rounded-full text-sm font-semibold">Start watching →</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input value={code} onChange={e=>setCode(e.target.value.toUpperCase())} placeholder="XXXX-XXXX-XXXX" className="w-full bg-white/5 border border-white/10 rounded-full px-6 py-4 text-lg tracking-widest text-center font-heading text-[#D4AF37] placeholder:text-white/20 focus:outline-none focus:border-[#D4AF37]/60" data-testid="redeem-code-input" maxLength={19}/>
            <button disabled={loading || !code.trim()} className="w-full btn-gold py-3 rounded-full font-semibold disabled:opacity-60" data-testid="redeem-submit">
              {loading ? "Checking…" : "Redeem"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
